// extracted by mini-css-extract-plugin
export default {"container":"ProjectInfoCard_container__1SY1O","topPadding":"ProjectInfoCard_topPadding__y2yh5"};